module.exports = __webpack_public_path__ + "static/media/opnestack.8cdbc2eb.png";